import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default function({ $config }, inject) {
  // console.log("Setup AMCharts /src/plugins/amcharts.js...");
  inject("am4core", am4core);
  inject("am4charts", am4charts);
  am4core.addLicense($config.AMCHARTS_KEY);
}
